var map = {
	"./modal_bg1.png": "HGxY",
	"./modal_bg2.png": "6BvJ",
	"./modal_bg3.png": "qgKO",
	"./modal_bgen.png": "szsq",
	"./modal_bgen1.png": "LPMa",
	"./modal_bgkhm.png": "GESK",
	"./modal_bgthai.png": "crhZ",
	"./modal_bgvi.png": "uerU",
	"./modal_bgzh-tw.png": "4RiE",
	"./modal_bgzh-tw1.png": "GqhM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BVWP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/modal_bg.*\.png$
// module id = BVWP
// module chunks = 1